import SourceLink from './SourceLink'

type UseSourceLinkProps = {
    children: any
}

export const useSourceLinkMarkdown = ({ children }: UseSourceLinkProps) => {
    const anchorElement = Array.isArray(children)
        ? children.find(child => child?.props && child?.props?.href) ||
          children.find(child => {
              return child?.props?.children[0]?.props && child?.props?.children[0]?.props?.href
          })?.props?.children?.[0]
        : children?.props && children?.props?.href
        ? children
        : null
    return { anchorElement }
}

const CardListItem = ({ children, ...props }: { children: React.ReactNode; props: any }) => {
    const { anchorElement } = useSourceLinkMarkdown({ children })

    if (
        typeof children === 'string' &&
        (children.trim() === '' || children.startsWith('{') || children.startsWith('['))
    ) {
        return null // Do not render if string is only whitespace, starts with "{" or "["
    }

    if (anchorElement) {
        return (
            <SourceLink
                link={anchorElement.props?.href}
                content={anchorElement.props?.children}
                secondary
            />
        )
    }

    return <li {...props}>{children}</li>
}

export default CardListItem
